import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { alertError, alertInfo, openStream } from "actions/ui";

class StreamOpenButton extends React.Component {

	get START_STREAM_COMMAND() {
		return 'startStream';
	}

	constructor(props) {
		super(props);

		this.state = {
			started: false
		}

		this.startStream = this.startStream.bind(this);
	}

	startStream() {
		 if (!this.props.streams.length) {
			 this.setState({ started: true }, this.sendStartCommand);
		 } else {
		 	this.props.alertError(this.props.i18n.oneStreamWarning);
		 }
	}

	sendStartCommand() {
		this.props.sendUserCommand('ss_' + this.props.type, this.START_STREAM_COMMAND, {type: this.props.type, ...this.props.parameters});
	}

	componentDidUpdate(prevProps) {
		const commandFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;
		const commandSuccess = this.props.command !== prevProps.command && this.props.command && this.props.command.success === true;

		if (commandFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand('ss_' + this.props.type);
			this.setState({ started: false });
		}

		if (commandSuccess) {
			this.props.openStream(this.props.command.result.stream.id, this.props.type, this.props.command.result.stream);
			this.props.clearUserCommand('ss_' + this.props.type);
			this.setState({ started: false });
		}
	}

	render() {
		return <button onClick={ this.startStream } disabled={ this.state.started } className="wcFunctional wcStreamStartButton wcStreamVideo" title={ this.props.label } />;
	}

}

StreamOpenButton.propTypes = {
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	parameters: PropTypes.object.isRequired
};

export default connect(
	(state, ownProps) => ({
		i18n: state.application.i18n,
		configuration: state.configuration,
		command: state.commands.sent['ss_' + ownProps.type],
		streams: state.ui.streams
	}), { sendUserCommand, clearUserCommand, alertError, alertInfo, openStream }
)(StreamOpenButton);